import { Text } from 'preact-i18n';

const EmptySearch = ({}) => (
  <div class="text-center mt-5 pt-5">
    <Text id="housesSettings.noHouseFound" />
  </div>
);

export default EmptySearch;
